<template>
  <div>
    <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :color="color"
    />
    <Header2 @setHidden="toggleWideBody" />

    <div class="rg-c">
      <div :class="wideBody ? 'wideBody' : 'gc-x'">
        <h2 class="hc-x">Transfer Transaction</h2>
        <main>
          <!-- Date Filters -->
          <!-- Filter Section -->
          <div class="filter-container">
            <!-- Date Range -->
            <div class="filter-group">
              <label>
                From:
                <select v-model="fromDay" @change="applyFilters">
                  <option v-for="d in daysInMonth" :key="'from-' + d" :value="d">
                    {{ d }}
                  </option>
                </select>
              </label>
              <label>
                To:
                <select v-model="toDay" @change="applyFilters">
                  <option v-for="d in daysInMonth" :key="'to-' + d" :value="d">
                    {{ d }}
                  </option>
                </select>
              </label>
            </div>

            <!-- Month & Year -->
            <div class="filter-group">
              <label>
                Month:
                <select v-model="month" @change="applyFilters">
                  <option v-for="(m, index) in months" :key="index" :value="index + 1">
                    {{ m }}
                  </option>
                </select>
              </label>
              <label>
                Year:
                <select v-model="year" @change="applyFilters">
                  <option v-for="y in ys" :key="y" :value="y">{{ y }}</option>
                </select>
              </label>
            </div>

            <!-- Search -->
            <div class="filter-group search-group">
              <label>
                Search:
                <input
                  type="search"
                  v-model="searchQuery"
                  @input="applyFilters"
                  placeholder="Search transaction ID"
                />
              </label>
            </div>
          </div>

          <!-- Search -->

          <!-- Export Buttons -->
          <div class="info-ipx-col">
            <button @click="downloadExcel">Export Excel</button>
            <button @click="downloadPDF">Export PDF</button>
          </div>

          <!-- Transactions Table -->
          <div class="icl-tbl">
            <table v-if="transactions.length" class="table-body" ref="exportableTable">
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Time</th>
                  <th>Receiver</th>
                  <th>Sender</th>
                  <th>Bal Before</th>
                  <th>Bal After</th>
                  <th>Amount</th>
                  <th>Source</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in transactions"
                  :key="item.id"
                  @click="goToTransactionDetail(item.user, item.ref)"
                >
                  <td>{{ item.ref }}</td>
                  <td>{{ moment(item.updated_at).format("DD-MM-YYYY") }}</td>
                  <td>{{ item.plan }}</td>
                  <td>{{ item.name }}</td>
                  <td>&#8358;{{ Intl.NumberFormat().format(item.bbefore) }}</td>
                  <td>&#8358;{{ Intl.NumberFormat().format(item.bafter) }}</td>
                  <td>&#8358;{{ Intl.NumberFormat().format(item.amount) }}</td>
                  <td>{{ item.m }}</td>
                  <td>{{ item.status == 1 ? "Completed" : "Failed" }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else style="text-align: center; font-weight: bold">
              No Transaction found
            </div>

            <!-- Pagination -->
            <div v-if="pageCount > 1" style="max-width: 950px; margin-top: 10px">
              <v-pagination
                v-model="currentPage"
                :pages="pageCount"
                @update:modelValue="applyFilters"
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Header2 from "../../components/header.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx/xlsx.mjs";
import VPagination from "@hennge/vue3-pagination";

export default {
  name: "TransferApp",
  components: { Header2, Loading, VPagination },
  data() {
    const today = new Date();
    const currentYear = today.getFullYear();
    return {
      isLoading: true,
      fullPage: true,
      color: "#0A1AA8",
      wideBody: false,
      moment,
      token: "",
      transactions: [],
      totalTransactions: 0,
      totalAmount: 0,
      currentPage: 1,
      searchQuery: "",
      fromDay: String(today.getDate()).padStart(2, "0"),
      toDay: String(today.getDate()).padStart(2, "0"),
      month: today.getMonth() + 1,
      year: today.getFullYear(),
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      ys: Array.from({ length: 51 }, (_, i) => currentYear - i),
      daysInMonth: new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate(),
    };
  },
  computed: {
    monthName() {
      return this.months[this.month - 1];
    },
    pageCount() {
      return Math.ceil(this.totalTransactions / 10); // assume per_page = 10
    },
  },
  methods: {
    toggleWideBody() {
      this.wideBody = !this.wideBody;
    },
    async fetchTransactions() {
      this.isLoading = true;
      try {
        const params = {
          type: 4,
          month: String(this.month).padStart(2, "0"),
          year: this.year,
          page: this.currentPage,
          search: this.searchQuery,
          fromDay: this.fromDay,
          toDay: this.toDay,
        };
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}api/gettransactions`,
          {
            headers: { Authorization: "Bearer " + this.token },
            params,
          }
        );
        this.transactions = res.data.data.data;
        this.totalTransactions = res.data.data.total;
        this.totalAmount = res.data.data.totalAmount || 0;
      } catch (e) {
        if (e.response && e.response.status === 401) {
          this.$router.push("/");
          localStorage.removeItem("admin");
        }
      } finally {
        this.isLoading = false;
      }
    },
    applyFilters() {
      this.currentPage = 1;
      this.fetchTransactions();
    },
    downloadExcel() {
      const wb = XLSX.utils.table_to_book(this.$refs.exportableTable, {
        sheet: "Sheet JS",
      });
      XLSX.writeFile(wb, `Transactions-${this.monthName}-${this.year}.xlsx`);
    },
    downloadPDF() {
      const doc = new jsPDF("p", "pt", "a2");
      window.html2canvas = html2canvas;
      doc.html(this.$refs.exportableTable, {
        callback: (pdf) => pdf.save(`Transactions-${this.monthName}-${this.year}.pdf`),
      });
    },
    goToTransactionDetail(userId, ref) {
      this.$router.push(`/userdetailtransaction/${userId}/${ref}`);
    },
  },
  mounted() {
    const adminData = JSON.parse(localStorage.getItem("admin"));
    this.token = adminData?.token || "";
    this.fetchTransactions();
  },
};
</script>

<style scoped>
.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  align-items: flex-end;
}

.filter-group {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  background: #f4f6fb;
  padding: 10px 15px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.filter-group label {
  display: flex;
  flex-direction: column;
  font-size: 0.95rem;
  font-weight: 500;
}

.filter-group select,
.filter-group input {
  padding: 6px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  outline: none;
  min-width: 100px;
}

.search-group {
  flex: 1 1 200px;
}

@media screen and (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    gap: 15px;
  }

  .filter-group {
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .search-group {
    width: 100%;
  }
}
.rg-c {
  font-family: "Quicksand", Georgia, "Times New Roman", Times, serif;
  font-size: 1.6rem;
  padding: 10px;
}

/* Container Styles */
.rg-c .gc-x,
.wideBody {
  margin: 100px auto;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);
  padding: 20px;
  border-radius: 15px;
}

/* Heading */
.hc-x {
  font-size: 1.4rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 20px;
}

/* Table Container */
.icl-tbl {
  width: 100%;
  overflow-x: auto;
  padding: 10px 0;
}

/* Table Styles */
.table-body {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-weight: 500;
  min-width: 900px;
}

.table-body thead {
  background: #0a1aa8;
  color: #fff;
}

.table-body thead th {
  font-size: 1rem;
  font-weight: 600;
  padding: 12px 15px;
  text-align: center;
  color: white;
}

.table-body tbody tr {
  background: #f8f9fa;
  transition: background 0.3s ease;
}

.table-body tbody tr:nth-child(even) {
  background: #eef2f7;
}

.table-body tbody tr:hover {
  background: #dbe4ff;
  cursor: pointer;
}

.table-body tbody td {
  padding: 10px 12px;
  font-size: 0.9rem;
  text-align: center;
  white-space: nowrap;
}

/* Status Badges */
.table-body tbody td:last-child {
  font-weight: 600;
}

.table-body tbody td.completed {
  color: #0f5132;
  background: #d1e7dd;
  border-radius: 12px;
  padding: 5px 10px;
}

.table-body tbody td.failed {
  color: #842029;
  background: #f8d7da;
  border-radius: 12px;
  padding: 5px 10px;
}

/* Pagination */
.v-pagination {
  justify-content: center;
  margin-top: 15px;
}

.v-pagination .active {
  background-color: #0a1aa8 !important;
  color: #fff !important;
  border-radius: 5px;
}

/* Summary Cards */
.cvlp {
  border-radius: 10px;
  background: #0a1aa8;
  color: #fff;
  padding: 15px;
  margin: 10px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.cvlp h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.cvlp span {
  font-size: 1rem;
}

/* Filters */
.info-ipx-col {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 15px;
  margin-bottom: 15px;
}

label {
  display: flex;
  flex-direction: column;
  font-size: 0.95rem;
}

select,
input[type="search"] {
  padding: 6px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  outline: none;
}

select {
  width: 100%;
}

/* Buttons */
button {
  background: #0a1aa8;
  color: #fff;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
}

button:hover {
  background: #081675;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .info-ipx-col {
    justify-content: flex-start;
  }
  .table-body {
    min-width: 700px;
  }
}

@media screen and (max-width: 490px) {
  .rg-c .gc-x,
  .wideBody {
    margin: 80px 10px 10px;
    padding: 15px;
  }
  .table-body {
    min-width: 600px;
  }
  .cvlp h3 {
    font-size: 0.9rem;
  }
  .cvlp span {
    font-size: 0.8rem;
  }
}
</style>
